export const FORMS_PREFIX = "Forms";

export const LOCAL_STORAGE_KEYS = {
    IsFolded: `${FORMS_PREFIX}_IsFolded`,
    CacheClearedOn: `${FORMS_PREFIX}_CacheClearedOn`,
    Projects: `${FORMS_PREFIX}_Projects`,
    SelectedPreset: `${FORMS_PREFIX}_SelectedPreset`,
    SelectedProject: `${FORMS_PREFIX}_SelectedProject`,
    AuthToken: `${FORMS_PREFIX}_AuthToken`,
    RefreshAuthToken: `${FORMS_PREFIX}_RefreshAuthToken`,
    LeftMenuOpenState: `${FORMS_PREFIX}_LeftMenuOpenState`,
};
